export default __webpack_public_path__ + "static/media/modernLoteryLogoBlanco.7330cff0.png";